import RefineWithAIButton from '@shared/refinement/RefineWithAIButton'
import stripHtml from '@shared/utils/stripHtml'
import { useFormContext, useWatch } from 'react-hook-form'
import useRecognitionMessageRefinement from './useRecognitionMessageRefinement'
import { RecognitionFormData } from './useSendRecognitionForm'

const RefineMessageButton: React.FC = () => {
  const {
    refineMessage,
    deleteRefinementMessage,
    hasRefined,
    isPendingRefineMessage,
    isPendingUndoRefinedMessage,
  } = useRecognitionMessageRefinement()
  const { control, clearErrors } = useFormContext<RecognitionFormData>()
  const message = useWatch({ control, name: 'message' })

  return (
    <RefineWithAIButton
      isMessageEmpty={stripHtml(message).length === 0}
      hasRefined={hasRefined}
      isPendingRefineMessage={isPendingRefineMessage}
      isPendingUndoRefinedMessage={isPendingUndoRefinedMessage}
      onBeforeRefine={() => clearErrors('root')}
      onRefine={refineMessage}
      onUndo={deleteRefinementMessage}
      refineButtonId="refineButton"
      undoButtonId="btnUndoRefine"
    />
  )
}

export default RefineMessageButton
